import { render } from "./legoModalExtend.vue?vue&type=template&id=77bbdc9f&scoped=true"
import script from "./legoModalExtend.vue?vue&type=script&lang=js"
export * from "./legoModalExtend.vue?vue&type=script&lang=js"

import "./legoModalExtend.vue?vue&type=style&index=0&id=77bbdc9f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bbdc9f"],['__file',"src/components/lego/extend/legoModalExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77bbdc9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77bbdc9f', __exports__)) {
    api.reload('77bbdc9f', __exports__)
  }
  
  module.hot.accept("./legoModalExtend.vue?vue&type=template&id=77bbdc9f&scoped=true", () => {
    api.rerender('77bbdc9f', render)
  })

}


export default __exports__